import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import useLink from '../../../../shared/hooks/linkHooks';

function renderValue(openLinksInNewTab, uri, value) {
    if (uri) {
        return (
            <a
                href={uri}
                rel="noreferrer"
                target={openLinksInNewTab ? '_blank' : ''}
            >
                {value}
            </a>
        );
    }

    return value;
}

function GaugeValueDisplay({
    gaugeValue,
    linkConfig,
    metricRequest,
    openLinksInNewTab,
    thresholdValue,
    thresholdLabel,
    valueStyles,
}) {
    const linkUri = useLink(linkConfig, metricRequest);

    return (
        <div className="gauge-value-display">
            <span
                className="gauge-value-display__value"
                style={valueStyles}
                data-testid="gauge-value-display"
            >
                {renderValue(openLinksInNewTab, linkUri, gaugeValue)}
            </span>
            {thresholdValue && (
                <span
                    className="gauge-value-display__threshold"
                    data-testid="gauge-value-threshold"
                >
                    {`${thresholdLabel} ${thresholdValue}`}
                </span>
            )}
        </div>
    );
}

GaugeValueDisplay.propTypes = {
    gaugeValue: PropTypes.node.isRequired,
    linkConfig: PropTypes.instanceOf(Object),
    metricRequest: PropTypes.instanceOf(Object).isRequired,
    openLinksInNewTab: PropTypes.bool.isRequired,
    thresholdLabel: PropTypes.string,
    thresholdValue: PropTypes.string,
    valueStyles: PropTypes.instanceOf(Object),
};

export default React.memo(
    GaugeValueDisplay,
    (prevProps, nextProps) =>
        _.isEqual(prevProps.gaugeValue, nextProps.gaugeValue) &&
        _.isEqual(prevProps.thresholdValue, nextProps.thresholdValue) &&
        _.isEqual(prevProps.linkUri, nextProps.linkUri)
);
